import React from 'react';

// Constants
import { FirstTimeItems, WelcomeBackItems } from './MeetingModeIntroModalBodyData.constants';

// Styles
import './MeetingModeIntroModalBody.scss';

type Props = {
  version: 'first-time' | 'welcome-back';
};

const MeetingModeIntroModalBody = ({ version }: Props) => {
  const data = version === 'first-time' ? FirstTimeItems : WelcomeBackItems;

  const baseClassName = 'MeetingModeIntroModalBody';
  return (
    <div className={baseClassName}>
      {data.map(item => (
        <div className={`${baseClassName}__item`} key={`meeting-mode-intro-modal-item-${item.title.replace(' ', '')}`}>
          <div>{item.icon}</div>
          <div className={`${baseClassName}__item__details`}>
            <p className={`${baseClassName}__item__details__title`}>{item.title}</p>
            <span className={`${baseClassName}__item__details__desc`}>{item.description}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MeetingModeIntroModalBody;
